import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import CryptoJS from 'crypto-js';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class CryptoWithdrawService {

  constructor(private http: HttpService) {
  }

  sendBatchTransaction(withdrawIds: number[], seed: string, isv5Wallet = false) {
    let encrypt: any;
    let checkPoint: string;
    const CryptoJSAesJson = {
      stringify: function(cipherParams: any) {
        const j: any = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
        if (cipherParams.iv) {
          j.iv = cipherParams.iv.toString();
        }
        if (cipherParams.salt) {
          j.s = cipherParams.salt.toString();
        }
        return JSON.stringify(j);
      },
      parse: function(jsonStr: string) {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
        if (j.iv) {
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
        }
        if (j.s) {
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
        }
        return cipherParams;
      }
    };
    return this.http.request('get', '/v1/admin/user/withdraw/auto/key').pipe(
      map((response: any) => response.data),
      mergeMap((data: any) => {
        encrypt = CryptoJS.AES.encrypt(JSON.stringify(seed), data.key, { format: CryptoJSAesJson }).toString();
        checkPoint = data.checkPoint;
        return this.http.request('post', '/v1/admin/user/withdraw/auto/crypto/ton', {
          withdrawId: withdrawIds,
          s: encrypt,
          checkPoint: checkPoint,
          walletVersion: isv5Wallet ? 'v5' : 'v2'
        });
      }),
      map((response: any) => response.data),
      map((data: any) => data.url as string)
    );

  }
}
